module.exports = __webpack_public_path__ + "img/temperature-thermometer-black.288723d4.svg";